import { MeshoptDecoder } from 'meshoptimizer';
export { MeshoptDecoder as default };